module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAMAAABhEH5lAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABFUExURQAAAJDP/5DP/5DP/5DP/5DP/5DP/5DP/5DP/5DP/5DP/5DP/5DP/5DP/5DP/5DP/5DP/5DP/5DP/5DP/5DP/5DP/5DP/6DfdRsAAAAWdFJOUwADBGa0F7cHtrjig5qhuWJkfH0YopuARO6dAAAAcklEQVQY022QWQ6AMAhER9vaVVs37n9Uq9LEWOZr8ggwAJg15RGPxpxWA5hARNrexOpqg0GkW64y6x4bMRMzJnRAvYa8Z6MwcLFJD3XE9CXuXTT9SWVLI56JgPrGfrwQQojaHTRLZwvPwb6l0l5Yzm3HBfdzEguwssIVAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/views/HomeManage/module/icons/icon-08.png
// module id = 6d1l
// module chunks = 4